goog.provide('el8.appchart.reportFeeds.actions');

goog.require('el8.appchart.dialog.addDiscreteLabValues');
goog.require('el8.appchart.dialog.docTags');
goog.require('el8.appchart.permissions');
goog.require('el8.appshared.dialog.reassignPatient');
goog.require('el8.appshared.feedItemActions');
goog.require('el8.appshared.feedItemActionsNew');
goog.require('el8.appshared.message');
goog.require('el8.appshared.signOff');
goog.require('el8.app.shared.dialog.linkOrder');
goog.require('el8.app.shared.dialog.viewInlinePdf');
goog.require('el8.app.shared.dialog.reportAttachments');
goog.require('el8.data.base');
goog.require('el8.model.identify');
goog.require('el8.ptdata.fetch');
goog.require('el8.ptdata.model.noteItem');
goog.require('el8.service.urls');
goog.require('el8.template.render.reportFeedItem');
goog.require('el8.util.amplitude.letterHelpers');
goog.require('el8.util.amplitude.orderHelpers');
goog.require('el8.util.amplitude.reportHelpers');
goog.require('el8.util.amplitude.patientFormHelpers');
goog.require('el8.util.consts');
goog.require('el8.util.feed');

goog.require('el8.appchart.mgr.orderForm');

//goog.require('el8.appchart.mgr.notes');
//goog.require('el8.appchart.mgr.thirdpane');
//goog.require('el8.appchart.dialog.reports');

el8.appchart.reportFeeds.actions = {};
el8.appchart.reportFeeds.actions.buttons = function(item) {

    if (el8Globals['TEASE']) { return []; }

    var mClass = item.getModelClass();

    switch (mClass) {
        case "Report":
            var buttonsInfo = [];
            if (!item.isSignedOff() && item.isSignOffAllowed()) {
                var label = el8.data.currUser.isPhysician() ? 'Sign Off' : 'Mark as Reviewed';
                buttonsInfo.push({ name : label, htmlClass : "signOffTrigger feedSignoff", isRealButton : true });
            }
            buttonsInfo.push({ name : "Actions", htmlClass: "report-feed-actions-trigger", hasDropdown: true });
            return buttonsInfo;
        case "LabOrder":
        case "ImagingOrder":
        case "SleepOrder":
        case "CardiacOrder":
        case "PulmonaryOrder":
        case "ReferralOrder":
            return [
                { name : "Actions", htmlClass: "report-feed-actions-trigger", hasDropdown: true }
            ];
        case "VisitNote":
        case "NonvisitNote":
            return [
                { name : "Actions", htmlClass: "report-feed-actions-trigger", hasDropdown: true }
            ];
        default:
            break;
    }
};

el8.appchart.reportFeeds.actions.contentButtons = function(item) {
    var mClass = item.getModelClass();

    if (el8Globals['TEASE']) { return []; }
    var isPatientFormCollection = el8.model.identify.isPatientFormCollection(item);


    var addLetterButtons = function(item, buttonsInfo) {
        var name = null;
        var isLink = item.isSignedOff(); // we display buttons for unsigned reports and links for signed ones
        if (el8Globals.FEATURES.Letters &&
            // If item has not been signed off, we don't want to show this button
            // for any non-physician users, not even the regular "Send" button
            // (you can't attach unsigned items). We don't want to show "Sign Off"
            // to staff users because it's clinically dangerous.
            //
            // This check should be logically equivalent to:
            // !(!el8.data.currUser.isPhysician() && !item.isSignedOff())
            (el8.data.currUser.isPhysician() || item.isSignedOff())
           ) {
            if (el8Globals.FEATURES.PatientPortal) {

                if (el8Globals.FEATURES.BiDiLabs) {
                    name = (item.isSignedOff()) ? "Send" : "Sign Off & Send";
                } else {
                    name = (item.isSignedOff()) ? "Send Report" : "Sign Off & Send";
                }

                buttonsInfo.push( { name : name, htmlClass: "send-letter-trigger", hasDropdown: true, isLink: isLink } );
            } else {
                    name = (item.isSignedOff()) ? "Send To Provider" : "Sign Off & Send to Provider";
                buttonsInfo.push( { name : name, htmlClass : "send-consultant-letter-trigger", isLink: isLink } );
            }
        }
    };

    switch (mClass) {
        case "Report":
            var buttonsInfo = [];
            if (!item.isSignedOff() && item.isSignOffAllowed()) {
                var label = el8.data.currUser.isPhysician() ? 'Sign Off' : 'Mark as Reviewed';
                buttonsInfo.push({ name : label, htmlClass : "signOffTrigger feedSignoff", isRealButton : true });
            } else {
                // Do not need "Reference in Note" button for lab reports that have structured result grids
                if (!isPatientFormCollection && item.getReportType() !== 'lab' || (item.getReportType() === 'lab' && !item.hasGrids())) {
                    buttonsInfo.push( { name : "Ref (HPI)", htmlClass : "reference-report-in-note", isLink: true } );
                }
            }

            var isLink = item.isSignedOff(); // we display buttons for unsigned reports and links for signed ones
            addLetterButtons(item, buttonsInfo);
            if (item.hasImages() && !item.isSignedOff()) {
                buttonsInfo.push( { name: "Annotate", htmlClass: "annotateTrigger", isLink: isLink } );
            }
            if (el8.data.currUser.getDefaultStaffGroupId()) {
                // if we don't have a default staff group, none of the messages will send anyways;
                // this basically translates to "show for physicians" but if we later add default groups for staff
                // or allow physicians to clear them, it'll be a little more accurate.
                buttonsInfo.push( { name : "Office Message", htmlClass: "premade-response-trigger", hasDropdown: true, isLink: isLink } );
            } else {
                buttonsInfo.push( { name : "Office Message", htmlClass: "write-message-trigger", isLink: isLink } );
            }
            buttonsInfo.push( { name: "Print", htmlClass: "printTrigger", isLink: isLink } );
            buttonsInfo.push( { name : "More Actions", htmlClass: "report-actions-trigger", hasDropdown: true, isLink: isLink } );
            if (el8.data.reportNoteTemplates.all().length) {
                buttonsInfo.push( { name : "Pre-Made Note", htmlClass: "premade-notes-trigger", hasDropdown: true, isLink: isLink } );
            }
            return buttonsInfo;

        case "LabOrder":
        case "ImagingOrder":
        case "SleepOrder":
        case "CardiacOrder":
        case "PulmonaryOrder":
        case "ReferralOrder":
            if (el8Globals.FEATURES.BiDiLabs) {
                var buttonsInfo = [];
                var state = item.getCurrentState();
                if (state === 'fulfilled') {
                    if (item.getCurrentStateResolvingDocumentId()) {
                        var docId = item.getCurrentStateResolvingDocumentId();
                        // interestingly customText is unused elsewhere...
                        buttonsInfo.push({name: "View Report", htmlClass: "item-details-trigger", isLink: true, customText: 'data-id='+docId });
                    } else {
                        buttonsInfo.push({name: "Fulfilled", htmlClass: "fulfilled-actions-trigger", hasDropdown: true, isLink: true });
                    }
                } else {
                    buttonsInfo.push({name: "Mark Fulfilled", htmlClass: "mark-fulfilled-trigger", isLink: true });
                }

                buttonsInfo.push({name: "Export to Note", htmlClass: "addToNoteTrigger", isLink: true });
                addLetterButtons(item, buttonsInfo);
                buttonsInfo.push({name: "More Actions", htmlClass: "order-actions-trigger", hasDropdown: true, isLink: true });
                return buttonsInfo;
            } else {
                var buttonsInfo = [];
                buttonsInfo.push( { name : "Export to Note", htmlClass : "addToNoteTrigger", isLink: true } );
                addLetterButtons(item, buttonsInfo);
                buttonsInfo.push( { name : "More Actions", htmlClass: "order-actions-trigger", hasDropdown: true, isLink: true } );
                return buttonsInfo;
            }
            break;
        case "VisitNote":
        case "NonvisitNote":
            return [];

        default:
            break;
    }
};

el8.appchart.reportFeeds.actions.genClickMap = function(rType, actionsMenu, twoColActionsMenu) {
    if (el8Globals['TEASE']) {
        return {
            '.overlayFeedHeaderContainer': function($target) {
                var fid = $target.attr('_fid');
                var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
                var feed = el8.appchart.reportFeeds.feeds[rType];
                feed.toggleItem(item);
                return false;
            },
            'a, button, span.result-row-actions-trigger': function($target) {
                if ($target.hasClass('el8LeftArrowIcon') || $target.hasClass('el8DownArrowIcon')) { return; }
                $(document).trigger('show-learn-more');
                return false;
            }
        };
    }
    // Helpers for the letter-related items on reports & orders
    var showLetterFn = function(item, letterType) {
        el8.appchart.mgr.thirdpane.attachToLetter({
            type: letterType,
            attachmentId: item.getId(),
            enforceStrictTypeMatch: true
        });
        // force the dialog over to the left, to uncover the letter
        el8.appchart.dialog.reports.show({
            item: item,
            forcePosition: 'left'
        });
    };
    var signAndShowLetterFn = function(item, letterType) {
        if (!item.isSignedOff()) {
            el8.appshared.signOff(item, function() {
                showLetterFn(item, letterType);
            });
        } else {
            showLetterFn(item, letterType);
        }
    };

    var addPrintSpecimenLabelsAction = function(item, menu) {
        menu.push({
            actionText: 'Print Specimen Labels',
            actionFn: function() {
                el8.appchart.printService.open({
                    attachmentId: item.getId(),
                    url: el8.service.urls.get('printSpecimenLabels', [item])
                }, true);
                return false;
            }
        });
    }

    var addDYMOLabelPrintingAction = function(item, menu) {
        menu.push({
            actionText: 'Print DYMO Specimen Labels',
            actionFn: function(item) {
                el8React.dispatch.openDymoPrintSpecimenLabelDialog({ labOrderId: item.getId() });
            }
        });
    }

    return {
        '.item-details-trigger': function($target) {
            var id = $target.data('id');
            if (el8.model.idToModelClass(id) === 'Handout') {
                el8.data.educationalHandouts.downloadById(id);
            } else {
                el8.appchart.showItemDetail(id);
            }
            return false;
        },
        '.view-inline-pdf': function($target) {
            var id = $target.data('id');
            el8.app.shared.dialog.viewInlinePdf.show({
                docFileId: id
            });
        },
        /**
         * These triggers apply regardless of whether item is expanded
         */
        '.report-feed-actions-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));

            var menuWidget;
            var actionList = el8.appshared.feedItemActionsNew(item, rType, 'report dialog');
            if (el8.model.identify.isOrder(item) || el8.model.identify.isNonvisitNote(item)) {
                menuWidget = actionsMenu;
            } else {
                menuWidget = twoColActionsMenu;
            }

            menuWidget.display(
                $target,
                item,
                {left: 20, top: 18},
                actionList,
                null,
                'el8FeedItemSelected'
            );
            return false;
        },
        '.overlayFeedHeaderContainer': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var feed = el8.appchart.reportFeeds.feeds[rType];
            feed.toggleItem(item);
        },
        /**
         * These triggers apply to items that are expanded (in content)
         */
        '.addToNoteTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            if (el8.model.identify.isOrder(item)) {
                el8.appchart.mgr.notes.addReference({item: item});

            } else if (el8.model.identify.isReport(item)) {
                el8.appchart.mgr.notes.addReference({item: item});

            } else if (item.is('DocumentAddendum')) {
                el8.appchart.mgr.notes.addReference({item: item, text: item.getNoteSummary(), sectionName: 'problem'});
            }
        },
        '.ref-note-trigger': function($target) {
            var fid = $target.attr('_fid');
            var report = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var itemId = $target.data('id');
            var noteItem = report.getNoteItemById(itemId);
            var prefix = report.getNoteSummary();
            var bulletText = prefix+': '+noteItem.getText();
            el8.appchart.mgr.notes.addReference({item: report, text: bulletText, sectionName: 'problem'});
        },
        '.document-collection-trigger': function($target) {
            if (el8Globals.FEATURES.InHouseLabWorkflow) {
                var orderId = $target.attr('data-id');
                el8React.dispatch.openSpecimenCollectionDialog({ labOrderId: orderId });
                el8.util.amplitude.logLabOrderActions('Document Collection', 'report view');
            }
        },
        '.order-actions-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            // Only showing a subset of the typical actions dropdown
            var menu = [];

            if (!el8Globals.FEATURES.BiDiLabs) {
                 menu.push({
                    actionText: 'Write Message',
                    actionFn: function() {
                        el8.appshared.message.prePopulateNewMessage({
                            toDocId: item.getId()
                        });
                    }
                });
            }

            if (el8Globals.FEATURES.BiDiLabs) {
                // New top section
                menu.push({type: 'heading', actionText: 'Order Status:'});

                if (item.getCurrentState() !== 'fulfilled') {
                    menu.push({
                        actionText: 'Fulfilled',
                        actionFn: function() {
                            el8.util.amplitude.logChangeOrderStatus('fulfilled', 'report dialog', item.getModelClass())
                            // Fulfill the order directly (doesn't need reminder)
                            el8.app.shared.dialog.reportAttachments.show({
                                callbackFn: function (attachmentItems) {
                                    var opts = {};
                                    opts.successCb = function() {
                                        el8.appchart.mainFeeds.outstanding.update();
                                    }
                                    if (attachmentItems.length) { // just one or none
                                        var attachment = attachmentItems[0];
                                        opts.resolvingDocumentId = attachment.getId();
                                    }
                                    item.fulfill(opts);
                                },
                                patientId: el8.ptdata.currPatient.getId()
                            });
                        },
                        indent: true
                    });
                }

                if (item.getCurrentState() !== 'outstanding') {
                    menu.push({
                        actionText: 'Outstanding',
                        actionFn: function() { 
                            el8.util.amplitude.logChangeOrderStatus('outstanding', 'report dialog', item.getModelClass());
                            var opts = {};
                            opts.successCb = function() {
                                el8.appchart.mainFeeds.outstanding.update();
                            }
                            item.outstanding(opts); },
                        indent: true
                    });
                }

                if (item.getCurrentState() !== 'cancelled') {
                    menu.push({
                        actionText: 'Canceled',
                        actionFn: function() {
                            el8.util.amplitude.logChangeOrderStatus('canceled', 'report dialog', item.getModelClass());
                            var opts = {};
                            opts.successCb = function() {
                                el8.appchart.mainFeeds.outstanding.update();
                            }
                            item.cancel(opts); 
                        },
                        indent: true
                    });
                }
                menu.push({type: 'line'});
            }

            menu.push({
                actionText: 'Reorder ' + item.getOrderType().capitalize(),
                actionFn: function() {
                    if (el8Globals.FEATURES.Letters && item.is('ReferralOrder')) {
                        item.reOrderWithLetter({
                            successCb: function(updatedLetter) {
                                el8.appchart.dialog.reports.hide();
                                el8.appchart.mgr.thirdpane.showLetter({letter: updatedLetter});
                                // manually log that we created a new referral
                                el8.util.amplitude.logStartLetter('re-order-action', el8.util.consts.REFERRAL_LETTER);
                            }
                        });
                    } else {
                        el8.appchart.mgr.orderForm.reOrderItem(item);
                    }

                }
            });

            menu.push({
                actionText: item.isConfidential() ? 'Unmark Confidential' : 'Mark Confidential',
                actionFn: function() {
                    var oldConfidentiality = item.isConfidential();
                    var inverseConfidentiality = !oldConfidentiality;
                    item.saveConfidentiality(inverseConfidentiality);
                }
            });

            menu.push({
                actionText: 'Print Order',
                actionFn: function() {
                    el8.appchart.printService.open({
                        attachmentId: item.getId(),
                        url: el8.service.urls.get('printOrder', [item])
                    });
                    return false;
                }
            });

            if (item.getModelClass() === 'LabOrder') {
                addPrintSpecimenLabelsAction(item, menu);

                if (el8Globals.FEATURES.DYMOLabels) {
                  addDYMOLabelPrintingAction(item, menu);
                }
            }

            actionsMenu.display($target, item, {left: 10, top: 20}, menu, null, 'el8FeedItemSelected');
            return false;
        },
        '.signOffTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var feed = el8.appchart.reportFeeds.feeds[rType];
            el8.appservice.notifier.notify(item.getNotifyText('SAVE_IN_PROGRESS'));
            el8.appshared.signOff(item, function() {
                feed.collapseItem(item);
                el8.appchart.dialog.reports.hide();
            });
            if (!el8.data.currUser.isPhysician()) {
                el8.util.amplitude.logStaffFormReview();
            }
            return false;
        },
        '.send-letter-trigger': function($target) {
            var fid = $target.attr('_fid');
            var report = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var menu = [];

            if (el8Globals.FEATURES.BiDiLabs) {
                menu.push({
                    actionText: 'Office Message',
                    actionFn: function() {
                        if (!report.isSignedOff()) {
                            el8.appshared.signOff(report, function() {
                                el8.appshared.message.prePopulateNewMessage({
                                    toDocId: report.getId()
                                });
                            });
                        } else {
                            el8.appshared.message.prePopulateNewMessage({
                                toDocId: report.getId()
                            });
                        }
                    }
                });
            }

            menu.push({
                actionText: 'To Provider (Letter)',
                actionFn: function() {
                    signAndShowLetterFn(report, el8.util.consts.CONSULTANT_LETTER);
                }
            });
            menu.push({
                actionText: 'To Provider (Referral)',
                actionFn: function() {
                    signAndShowLetterFn(report, el8.util.consts.REFERRAL_LETTER);
                }
            });
            menu.push({
                actionText: 'To Patient',
                actionFn: function() {
                    signAndShowLetterFn(report, el8.util.consts.PATIENT_LETTER);
                }
            });

            if (report.getModelClass() === 'LabOrder') {
                if (report.isSendToLabEnabled()) {
                    if (!report.getSubmissionTime()) {
                        menu.push({
                            actionText: 'Send to LIS',
                            actionFn: function() {
                                el8.appchart.mgr.orderForm.sendLabOrderToLab(report, function(labOrder) {
                                    el8.appchart.dialog.reports.ensureRefresh('lab');
                                });
                            }
                        });
                    }
                }
            }

            var menuOffset;
            var leftOffset = 182;
            if (!report.isSignedOff()) {
                menuOffset = {left: leftOffset, top: 24};
            } else {
                menuOffset = {left: leftOffset, top: 21};
            }
            actionsMenu.display($target, report, menuOffset, menu, null, 'el8ItemSelected');
            return false;
        },
        '.send-consultant-letter-trigger': function($target) {
            var fid = $target.attr('_fid');
            var report = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            signAndShowLetterFn(report, el8.util.consts.CONSULTANT_LETTER);
        },
        '.premade-response-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var menu = el8.appshared.message.getPremadeResponseMenu({
                item: item,
                callbackFn: function(body, threadId) {
                    item.addThreadId(threadId);
                    var thread = el8.ptdata.messageThreads.getById(threadId);
                    var $elt = el8.appchart.reportFeeds.feeds[rType].getRenderItem(item.getId());
                    $('.referring-threads', $elt).append(
                        el8.template.render.reportFeedItem.thread({
                            thread: thread.asSoyMap()
                        })
                    );
                }
            });
            menu.push({
                actionText: 'Write Message',
                actionFn: function() {
                    el8.appchart.dialog.reports.writeReportMessage(item, rType);
                }
            });
            var menuOffset = null;
            if (!item.isSignedOff()) {
                menuOffset = {left: 86, top: 24};
            } else {
                menuOffset = {left: 63, top: 21};
            }
            actionsMenu.display($target, item, menuOffset, menu, null, 'el8ItemSelected');
            return false;
        },
        '.write-message-trigger': function($target) {
            var fid = $target.attr('_fid');
            var report = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.dialog.reports.writeReportMessage(report, rType);
        },
        '.premade-notes-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var menu = el8.data.reportNoteTemplates.all().map(function(t) {
                return {
                    actionText: t.getText(),
                    actionFn: function() {
                        if (!item.isSignedOff()) {
                            var noteItem = el8.ptdata.model.noteItem({});
                            noteItem.setText(t.getText());
                            el8.appchart.reportFeeds.listeditors[item.getId()].addEntry(noteItem);
                        } else {
                            var newAddendum = el8.ptdata.addendums.create({
                                text: t.getText(),
                                referenced_document_id: item.getId()
                            });
                            el8.ptdata.addendums.saveItem(newAddendum, false, {
                                successCb: function() {
                                    var $elt = el8.appchart.reportFeeds.feeds[rType].getRenderItem(item.getId());
                                    $('.referring-addendums', $elt).append(
                                        el8.template.ptdata.addendums.reportSummary({
                                            item: newAddendum.asSoyMap()
                                        })
                                    );
                                    item.addAddendumId(newAddendum.getId());
                                    el8.appchart.mainFeeds.chart.update();
                                }
                            });
                        }
                    }
                };
            });
            var menuOffset;
            if (item.getReportType() !== 'lab' || (item.getReportType() === 'lab' && !item.hasGrids())) {
                // we're showing the HPI button, so this button is on the second row and needs to be adjusted
                if (!item.isSignedOff()) {
                    menuOffset = {left: 86, top: 22};
                } else {
                    menuOffset = {left: 68, top: 20};
                }
            } else {
                menuOffset = {left: 6, top: 21};
            }
            actionsMenu.display($target, item, menuOffset, menu, null, 'el8ItemSelected');
            return false;
        },
        '.reference-report-in-note': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.mgr.notes.addReference({item: item, sectionName: 'problem'});
        },
        '.addToNoteHpiTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var assessmentId = $target.attr('assessmentid')*1;
            var assessment = item.getBulletSets()['Assessment'].getById(assessmentId) ||
                item.getBulletSets()['Assessplan'].getById(assessmentId);
            if (assessment) {
                el8.appchart.mgr.notes.addText(assessment.getText(), 'problem');
            } else {
                UIM && UIM.logError('Tried to Ref (HPI) assessment but could not find it. ID: '+assessmentId);
            }
        },
        '.printTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            item.printReport();
        },
        '.annotateTrigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var pageTotal = item.getFullSizeImages().length;
            el8React.dispatch.openAnnotationsDialog({
                reportId: item.getId()
            });
            el8.util.amplitude.logAnnotateReportV2('reports panel', item.getId(), item.getReportType(), pageTotal);
        },
        '.report-actions-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var menu = [];
            var isPatientFormCollection = el8.model.identify.isPatientFormCollection(item);

            if(!isPatientFormCollection) {
                if (item.getReportType() === 'lab' && item.hasGrids()) {
                    menu.push({
                        actionText: 'Reference All Starred in Note',
                        actionFn: function() {
                            var results = item.getStarredResults();
                            if (results.length) {
                                el8.appchart.mgr.notes.doActiveNote(function() {
                                    for( var i=0; i<results.length; i++ ) {
                                        el8.appchart.mgr.notes.addReference({item: results[i]});
                                    }
                                });
                            }
                        }
                    });
                    menu.push({
                        actionText: 'Reference All Abnormal Values in Note',
                        actionFn: function() {
                            var results = item.getAbnormalResults();
                            if (results.length) {
                                el8.appchart.mgr.notes.doActiveNote(function() {
                                    for( var i=0; i<results.length; i++ ) {
                                        el8.appchart.mgr.notes.addReference({item: results[i]});
                                    }
                                });
                            }
                        }
                    });
                }
                if (item.getReportType() === 'lab' && item.isAllowManualEdit()) {
                    //only Labs with without integrations should allow manual add
                    menu.push({
                        actionText: 'Add Lab Values For Trending',
                        actionFn: function( item ) {
                            el8.appchart.dialog.addDiscreteLabValues.show(item.getId());
                        }
                    });
                }

                if (el8Globals.FEATURES.BiDiLabs) {
                    if (item.getReportType() === 'lab' && (item.hasGrids() || item.isAllowManualEdit())) {
                        menu.push({type: 'line'});
                    }

                    if (item.getOriginatingOrderId()) {
                         menu.push({
                            actionText: 'View Order',
                            actionFn: function() {
                                el8.appchart.showItemDetail(item.getOriginatingOrderId());
                            }
                        });

                    } else {
                         menu.push({
                            actionText: 'Link to Order',
                            actionFn: function() {
                                el8.app.shared.dialog.linkOrder.show({reportId: item.getId()});
                            }
                        });
                    }
                    menu.push({type: 'line'});
                }
            }


            menu.push({
                actionText: 'Re-File to Another Patient Chart',
                actionFn: function( item ) {
                    el8.appshared.dialog.reassignPatient.show({
                        docId: item.getId()
                    });
                }
            });
            if(!isPatientFormCollection) {
                menu.push({
                    actionText: 'Mark Previous Report As \"Partial\"',
                    actionFn: function( item ) {
                        el8.render.content.renderPreviousReportAsPartial( item );
                    }
                });
            }
            if (isPatientFormCollection && !(item.getReportType() === 'lab' && item.hasGrids())) {
                menu.push({
                    actionText: 'Merge Into Another Report',
                    actionFn: function( item ) {
                        el8.render.content.renderMergeIntoReport( item );
                    }
                });
            }
            menu.push({
                actionText: 'Remove Report',
                actionFn: function( item ) {
                    item.deleteReport();
                }
            });
            if (!isPatientFormCollection && (item.getReportType() !== 'lab' || !item.hasGrids())) {
                menu.push({
                    actionText: 'Remove & Re-File Images',
                    actionFn: function( item ) {
                        item.deleteReport(true);
                    }
                });
            }
            var menuOffset = null;
            if (!item.isSignedOff()) {
                menuOffset = {'top': 23, 'left': 15};
            } else {
                menuOffset = {'top': 21, 'left': 5};
            }
            actionsMenu.display($target, item, menuOffset, menu, null, 'el8FeedItemSelected');
            return false;
        },
        '.result-row-actions-trigger': function($target) {
            var resultId = $target.attr('resultId');
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var menu = [];
            menu.push({
                actionText: 'Export to Note with Matched Prob (HPI & A)',
                actionFn: function() {
                    el8.appchart.mgr.notes.autoImportLabsProblems({
                        type: 'results',
                        resultId: resultId,
                        reportId: item.getId()
                    });
                }
            });
            menu.push({
                actionText: 'Export to Note (HPI)',
                actionFn: function() {
                    var labResult = item.getResultRow(resultId);
                    el8.appchart.mgr.notes.addReference({item: labResult, sectionName: 'problem'});
                }
            });
            menu.push({
                actionText: 'Export to Note (Data)',
                actionFn: function() {
                    var labResult = item.getResultRow(resultId);
                    el8.appchart.mgr.notes.addReference({item: labResult});
                }
            });
            menu.push({
                actionText: 'Export to Note (Data w/ Past Dates)',
                actionFn: function() {
                    var labResult = item.getResultRow(resultId);
                    el8.appchart.mgr.notes.addReference({
                        item: labResult,
                        showPrevLabResultDates: true
                    });
                }
            });
             menu.push({
                actionText: 'Export to Note (HPI Sub-Bullet)',
                actionFn: function() {
                    var labResult = item.getResultRow(resultId);
                    el8.appchart.mgr.notes.addProblemSubBullet(labResult);
                }
            });
            actionsMenu.display($target, null, {'top': 16, 'left': 20} , menu, null, 'el8ItemSelected');
            return false;
        },
        '.star-trigger': function($target) {
            var resultId = $target.attr('resultId');
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var resultRow = item.getResultRow(resultId);
            var isStarred = resultRow.isStarred();
            resultRow.setStarred(!isStarred);
            if (resultRow.isStarred()) {
                $target.closest('.result-row').addClass('starred');
            } else {
                $target.closest('.result-row').removeClass('starred');
            }
            resultRow.save();
            return false;
        },
        '.download-imported-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            item.downloadImportedFiles();
            return false;
        },
        '.add-edit-tags-trigger': function($target) {
            var fid = $target.attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.dialog.docTags.show({doc: item});
            return false;
        },
        '.remind-later-trigger': function($target) {
            var reminder = el8.ptdata.documentReminders.getById($target.data('reminder-id'));
            reminder.getNewDate();
            return false;
        },
        '.fulfilled-actions-trigger': function($target) {
            // This is for when the order is fulfilled, but no report was attached.
            // Show a drop down menu with access to report attachment dlg and cancel action
            var fid = $target.attr('_fid');
            var order = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));

            var menu = [];
            menu.push({
                actionText: 'Attach Report',
                actionFn: function() {
                    var opts = {};
                    el8.app.shared.dialog.reportAttachments.show({
                        callbackFn: function (attachmentItems) {
                            if (attachmentItems.length) { // just one or none
                                var attachment = attachmentItems[0];
                                opts.resolvingDocumentId = attachment.getId();
                            }
                            order.fulfill(opts);
                        },
                        patientId: el8.ptdata.currPatient.getId()
                    });
                    return false;
                }
            });
            menu.push({
                actionText: 'Mark Cancelled',
                actionFn: function() { order.cancel(); }
            });
            actionsMenu.display($target, order, {left: 200, top: 20}, menu, null, 'el8FeedItemSelected');
            return false;
        },
    '.mark-fulfilled-trigger': function($target) {
            // just orders
            var fid = $target.attr('_fid');
            var order = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            var opts = {};
            opts.successCb = function() {
                el8.appchart.mainFeeds.outstanding.update();
            }
            el8.util.amplitude.logMarkFulfilled(order.getModelClass());

            // Fulfill the order directly (doesn't need reminder)
            el8.app.shared.dialog.reportAttachments.show({
                callbackFn: function (attachmentItems) {
                    if (attachmentItems.length) { // just one or none
                        var attachment = attachmentItems[0];
                        opts.resolvingDocumentId = attachment.getId();
                    }

                    order.fulfill(opts);
                },
                patientId: el8.ptdata.currPatient.getId()
            });

            return false;
        }
    };
};
